<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <textarea v-show="debug" style="height: 100%" v-model="hi">
        </textarea>
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">{{ this.curation.title }}</h3>
              <p class="lead">

              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th rowspan="2">노출일</th>
                        <th rowspan="2">제목</th>
                        <th rowspan="2">산업군</th>
                        <th colspan="3">메일</th>
                        <th rowspan="2">구독자 조회수</th>
                        <th rowspan="2">구독자 누적 조회수</th>
                        <th rowspan="2">누적 조회수</th>
                        <th rowspan="2">미리 보기</th>
                      </tr>
                      <tr>
                        <th>발송 수</th>
                        <th>오픈 수</th>
                        <th>오픈율</th>
                      </tr>
                      <tr>
                        <td>{{ this.curation.createDate }}</td>
                        <td>{{ this.curation.title }}</td>
                        <td>
                          <span v-for="industry in this.curation.industries" :key="industry.index" class="ml-1 label-industry">
                            {{industry}}
                          </span></td>
                        <td>{{ curation.mailSendCount }}</td>
                        <td>{{ curation.mailReadCount }}</td>
                        <td>{{ curation.mailReadRate }}</td>
                        <td>{{ curation.subSendCount }}</td>
                        <td>{{ curation.subTotalCount }}</td>
                        <td>{{ curation.readCount }}</td>
                        <td>
                          <button @click="showPreview(curation.idx)">View</button>
                        </td>
                      </tr>
                    </table>
                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center">
                    <div class="h4 fl ml-2 mb-2">메일 수신자 리스트</div>
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th style="width: 10%; min-width: 120px">검색</th>
                        <td style="width: 10%; min-width: 120px">
                          <select name="selectOption">
                            <option value="name">이름</option>
                            <option value="email">ID(E-mail)</option>
                          </select>
                        </td>
                        <td>
                          <input v-show="selectedOption === 'name'" @keyup.enter="getCurationSendSubscribeDetail()"
                                 v-model="filter.queryString" type="text" class="form-control" id="colFormLabel" placeholder="검색어를 입력하세요.">
                        </td>
                      </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="text-right mt-2">
                    <button type="submit" class="btn btn-primary" @click="getCurationSendSubscribeDetail()">
                      검색
                    </button>
                  </div>
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <select name="isSend" class="form-control fl w-20per">
                        <option value="">발송 여부</option>
                        <option value="Y">오픈</option>
                        <option value="N">미오픈</option>
                      </select>
                    </div>
                  </div>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th class="wd-10p-f">No</th>
                        <th class="wd-10p-f">구분</th>
                        <th class="wd-10p-f">이름</th>
                        <th>ID(E-mail)</th>
                        <th class="wd-10p-f">메일 오픈 여부</th>
                        <th class="wd-10p-f">앱 조회 여부</th>
                      </tr>
                      <tr v-for="(record, index) in this.records" :key="record.index">
                        <td>{{ (records.length) - index }}</td>
                        <td>{{ record.user.division }}</td>
                        <td>{{ record.user.userName }}</td>
                        <td><p style="color:#0e4cfd" class="cursor-pointer" @click="moveCurationCheck(record.user.idx)">
                          {{ record.user.uid }}
                        </p></td>
                        <td>{{ record.isRead }}</td>
                        <td>{{ record.isAppRead }}</td>
                      </tr>
                    </table>
                  </div>

                  <div v-show="this.lastpage > 0" style="padding-left:35%; padding-top:20px;">
                    <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                              :click-handler="curationPageCallback" :prev-text="'Prev'"
                              :next-text="'Next'" :container-class="'pagination'"
                              :page-class="'page-link'">
                    </paginate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/commons/IncMenu.vue'
import CurationComponent from "@/components/model/curationComponent";
import Paginate from 'vuejs-paginate';

export default {
  mixins: [CurationComponent],
  name: 'curationDetail',
  components: {
    Menu,
    Paginate
  },

  data: () => ({
    debug: false,
    selectedOption : 'name'
  }),

  computed: {
    hi: function () {
      return JSON.stringify(this.records);
    },
  },

  methods: {
    getCurationSendSubscribeDetail(){
      let selectedOption = document.querySelector('select[name=selectOption]').value;
      let isSend = document.querySelector('select[name=isSend]').value;
      if(selectedOption === 'email') this.getCurationSendSubscribe(1, this.$route.params.idx, null, this.filter.queryString, isSend);
      else if(selectedOption === 'name') this.getCurationSendSubscribe(1, this.$route.params.idx, this.filter.queryString, null, isSend);
      else this.getCurationSendSubscribe(1, this.$route.params.idx, null, null, isSend);
    }
  },

  mounted() {
    const idxCuration = this.$route.params.idx;
    this.getCurationDetail(idxCuration);
    this.getCurationSendSubscribeDetail();
  },
}
</script>

<style scoped lang="scss">

</style>
